import React, {useState} from 'react';
import {formatDate, formatPeso} from '../../helpers';

import {
  Box,
  Button, FormControlLabel,
  IconButton, Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Theme,
} from '@mui/material';

import makeStyles from "@mui/styles/makeStyles";
import {Close} from '@mui/icons-material';
import {useLocation, useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../..//redux/hooks";
import Strings from "../../assets/strings";
import {ConfirmDialog} from "../../components";
import {IAppUser, IAppUserPago} from "../../redux/types/IAppUser";
import {eliminarAppUserPago} from "../../redux/reducers/appUsersReducers";


const useStyles = makeStyles((theme:Theme) => ({
  root: {
    // width: '100%',
    // overflowX: 'auto',
  },
  barTitle:{
    // padding: "6px 12px",
    // background: theme.palette.grey[200],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& > label':{
      marginRight: 0
    }
  },
  pagAnulado:{
    background: "#fff1f1",
    "& td, th":{
      color:theme.palette.error.light,
    }
  },
}));

export default function ListPagosUser({ data = [], onTabClick,notasCount }:{notasCount?:number, data:IAppUserPago[], onTabClick:(tab:number)=>void}) {
  const classes = useStyles();
  let navigate = useNavigate();
  const {state:urlState, pathname} = useLocation();
  let dispatch = useAppDispatch();
  let {byId:appUser = ({} as IAppUser)} = useAppSelector(state => state.appUsers);
  const [showAnulado, setShowAnulado] = useState(false);

  //----
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event:any, newPage:number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <div className={classes.barTitle}>
        <Box display={"flex"}>
          <Button onClick={()=>onTabClick(1)} variant="text" sx={{textTransform: "capitalize",height: "30px", background:"#eeeeee !important"}}>{Strings.pagos}</Button>
          <Button onClick={()=>onTabClick(2)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>Modulos</Button>
          <Button onClick={()=>onTabClick(3)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>
            {Strings.notas} ({notasCount ??0})
          </Button>
        </Box>
        <FormControlLabel className="d-print-none"
                          control={
                            <Switch
                                //disableRipple
                                size={"small"}
                                color={"secondary"}
                                checked={showAnulado}
                                onChange={()=>setShowAnulado(!showAnulado)}
                                value="checkedB"
                            />
                          }
                          label={Strings.anulado}
        />
      </div >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell/>
              <TableCell sx={{width:150}}>{Strings.fecha}</TableCell>
              <TableCell>Monto</TableCell>
              <TableCell>Cuotas</TableCell>
              <TableCell>Referencia</TableCell>
              <TableCell>Concepto</TableCell>
              <TableCell>Fecha Próximo Pago</TableCell>
              <TableCell>Fecha Anulación</TableCell>
              <TableCell>{Strings.comentario}</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {data.filter(p=>!p.fechaAnulacion || Boolean(p.fechaAnulacion) === showAnulado ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n =>
                <TableRow key={n.id}
                          className={!!n.fechaAnulacion? classes.pagAnulado: ""}
                >
                  <TableCell className={"actionCell"}>
                        <IconButton
                            onClick={()=>navigate(pathname,{state:{confirmDialog: {pagoId: n.id!}}})}
                            size="large">
                          <Close className={"text-red"}/>
                        </IconButton>
                  </TableCell>
                  <TableCell>{formatDate(n.fechaCreacion)} {formatDate(n.fechaCreacion,"h:mm a")}</TableCell>
                  <TableCell>{formatPeso(n.monto)}</TableCell>
                  <TableCell>{n.cuotas}</TableCell>
                  <TableCell>{n.referencia}</TableCell>
                  <TableCell>{n.concepto}</TableCell>
                  <TableCell>{formatDate(n.fechaProximoPago)}</TableCell>
                  <TableCell>{formatDate(n.fechaAnulacion)}</TableCell>
                  <TableCell>{n.comentario}</TableCell>

                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length > 10 &&
          <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={data.length - (!showAnulado ? data.filter(p=>!!p.fechaAnulacion).length:0)}
              rowsPerPage={rowsPerPage}
              SelectProps={{
                inputProps: {'aria-label': 'No. registros'},
                native: true,
              }}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
          />
      }

      {urlState?.confirmDialog?.pagoId &&
          <ConfirmDialog onConfirm={()=>{
            dispatch(eliminarAppUserPago({id:urlState?.confirmDialog?.pagoId, companiaId: appUser.id!}))
          }}/>
      }
    </>
  );
}

